import { Component, OnInit } from '@angular/core';
import {GlobalService} from "../../../../global.service";
import {EventsService} from "../../../events.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-tecno-tournaments',
  templateUrl: './tecno-tournaments.component.html',
  styleUrls: ['./tecno-tournaments.component.scss']
})
export class TecnoTournamentsComponent implements OnInit {
  tournaments = [];

  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }
  ngOnInit(): void {
    this.activeRoute.params.subscribe(param => {
      this.changeRoute();
    });
  }
  changeRoute() {
    this.eventService.loadEventTournaments = true;
    this.eventService.getEventTournaments('tecno-pubg-mobile-cup', 1, 'pubg').subscribe(res => {
      this.eventService.eventTournaments.next(res);
      this.eventService.loadEventTournaments = false;
    }, error => {
      this.eventService.eventTournaments.next({data: []});
      this.eventService.loadEventTournaments = false;
    })
  }

}
